// v0.10.0 — Bond, RewardBurst, PetWishCard, PetProfile copy.
const zh = {
  'rewardBurst.levelUp.eyebrow': '亲密度升级',
  'rewardBurst.levelUp.unlock':  '解锁：',
  'rewardBurst.bondShort':       '亲密度',
  'rewardBurst.wish.title':      '{name} 的心愿被满足啦！',

  'bond.badge.lvl':              '亲密度 Lv.',
  'bond.profile.title':          '亲密度档案',
  'bond.profile.totals.taps':    '抚摸次数',
  'bond.profile.totals.feeds':   '喂食次数',
  'bond.profile.totals.chats':   '聊天次数',
  'bond.profile.totals.plays':   '游戏次数',
  'bond.profile.totals.wishes':  '心愿满足',
  'bond.profile.unlocks':        '羁绊里程碑',
  'bond.profile.unlocked':       '已解锁',
  'bond.profile.locked':         '未解锁',
  'bond.profile.next':           '下一关：还差 {xp} 经验',

  'wish.card.title':             '{name} 的心愿',
  'wish.card.cta':               '前往满足',
  'wish.card.expires':           '剩 {hours} 小时',
  'wish.card.empty':             '它正在想要什么…',
  'wish.shop.ribbon':            '💗 {name} 的心愿',

  'idle.bubble.hungry':          '肚肚咕咕响…',
  'idle.bubble.wantPlay':        '我们玩点什么吧！',
  'idle.bubble.snuggle':         '你能再摸摸我吗？',

  'chat.qr.placeholder':         '点一下快速回复',
};

const en = {
  'rewardBurst.levelUp.eyebrow': 'Bond level up',
  'rewardBurst.levelUp.unlock':  'Unlocked:',
  'rewardBurst.bondShort':       'Bond',
  'rewardBurst.wish.title':      "{name}'s wish came true!",

  'bond.badge.lvl':              'Bond Lv.',
  'bond.profile.title':          'Bond Profile',
  'bond.profile.totals.taps':    'Pets',
  'bond.profile.totals.feeds':   'Feeds',
  'bond.profile.totals.chats':   'Chats',
  'bond.profile.totals.plays':   'Plays',
  'bond.profile.totals.wishes':  'Wishes',
  'bond.profile.unlocks':        'Bond Milestones',
  'bond.profile.unlocked':       'Unlocked',
  'bond.profile.locked':         'Locked',
  'bond.profile.next':           'Next: {xp} XP to go',

  'wish.card.title':             "{name}'s wish",
  'wish.card.cta':               'Make it happen',
  'wish.card.expires':           '{hours}h left',
  'wish.card.empty':             "Wondering what it wants...",
  'wish.shop.ribbon':            "💗 {name}'s wish",

  'idle.bubble.hungry':          'My tummy is rumbling...',
  'idle.bubble.wantPlay':        "Let's play something!",
  'idle.bubble.snuggle':         'Can you pet me again?',

  'chat.qr.placeholder':         'Tap a quick reply',
};

export default { zh, en };
